import { Fragment, JSX } from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, FieldValues, UseFormRegister } from 'react-hook-form';
import { Typeahead } from 'react-bootstrap-typeahead';
import { IField } from '../interfaces/field.interface';

interface IOwnProps<T extends FieldValues> {
  fields: Array<IField>;
  control: Control<T, any>;
  register: UseFormRegister<T>;
  floating?: boolean;
}
export function Fields<T extends FieldValues>({ fields, control, register, floating }: IOwnProps<T>): JSX.Element {

  const renderElement = (fieldElement: IField) => {
    const { label, required, requiredOptions, options, props } = fieldElement;
    return props.type === 'typeahead' ? (<Controller
      name={props.name}
      control={control}
      render={({ field }) => (
        <Typeahead
          {...field}
          id={props.name}
          labelKey="name"
          onChange={selected => {
            field.onChange(selected[0]);
            if (fieldElement.onChange) {
              fieldElement.onChange();
            }
          }}
          options={options || []}
          placeholder={`Choose a ${label}`}
          selected={field.value ? [field.value] : []}
        />
      )}
    />) : (props.type === 'select' ? (
      <Form.Select
        {...props}
        {...register(props.name, { required, ...requiredOptions })}
      >
        {(options ?? []).map((option) => <option key={`option-${props.name}-${option.id}`} value={option.id}>{option.name}</option>)}
      </Form.Select>) : (props.type === 'switch' ? (
        <Form.Check
          {...props}
          {...register(props.name, { required, ...requiredOptions })}
          type="switch"
          id={`switch-${props.name}`}
          label={label}
        />
      ) : (<Form.Control
        {...props}
        {...register(props.name, { required, ...requiredOptions })}
      />)))
  }

  return (
    <Fragment>
      {fields.map((fieldElement, index) => {
        const { label, props } = fieldElement;
        return (
          <Form.Group key={`form-element-${index}`} className="mb-3">
            {props.type === 'switch' ? renderElement(fieldElement) : floating ?
              <Form.FloatingLabel label={label} className="mb-3">
                {renderElement(fieldElement)}
              </Form.FloatingLabel> : <>
                <Form.Label>{label}</Form.Label>
                {renderElement(fieldElement)}
              </>}
          </Form.Group>
        );
      })}
    </Fragment>
  );
};